import {createElement} from 'methods/utils';
import UnauthorizedUser from 'methods/unauthorized-user';

/**
 * Загрузчик файлов
 * @param {Element} $element Контейнер для звёзд
 */
function PhotogalleryUploader($container) {
    this._$container = $container;
    this._$element   = this._$container.firstElementChild;
    this._user       = new UnauthorizedUser();

    this.options = {
        pid:              parseInt(this._$container.dataset.pid, 10) || 0,
        mid:              parseInt(this._$container.dataset.mid, 10) || 0,
        accept:           this._$container.dataset.accept            || [],
        maxFileSize:      this._$container.dataset.maxFileSize       || 20 * 1024 * 1024, // 20mb
        maxFilesCount:    this._$container.dataset.maxFilesCount     || 12,
        exclude:          this._$container.dataset.exclude           || [],
        hash:             this._$container.dataset.hash,
        is_hotel_recalls: this._$container.dataset.is_hotel_recalls  || false,
    };

    if (this.options.accept) {
        this.options.accept = this.options.accept.split(',');
    }

    if (this.options.exclude) {
        this.options.exclude = this.options.exclude.split(',');
    }

    // хранилище фоток
    this._files = [];

    this._$images  = this._$element.querySelector('.js-uploaderImages');
    this._$open    = this._$element.querySelector('.js-uploaderOpen');
    this._$input   = this._$element.querySelector('input[type="file"]');
    this._$wrapper = this._$element.querySelector('.js-uploaderWrapper');

    // дизайн нарисовал фотки вне контейнера
    if (this.options.is_hotel_recalls) {
        this._$wrapper.parentNode.parentNode.append(this._$images);
    }

    this._$input.addEventListener('change', PhotogalleryUploader.prototype._onChange.bind(this));

    this._$open.addEventListener('click', e => {
        this._$input.click();
    });

    this._$element.addEventListener('dragenter', e => {
        e.stopPropagation();
        e.preventDefault();
    });

    this._$wrapper.addEventListener('dragleave', e => {
        e.stopPropagation();
        e.preventDefault();
    });

    this._$wrapper.addEventListener('dragover', e => {
        e.stopPropagation();
        e.preventDefault();
    });

    this._$wrapper.addEventListener('drop', e => {
        e.stopPropagation();
        e.preventDefault();

        Array.prototype.forEach.call(e.dataTransfer.files, this.add.bind(this));
    });

    // количество фотографий
    Object.defineProperty(this, 'length', {
        get: this.getLength.bind(this),
        configurable: true,
        enumerable: true,
    });

    // грузим фотки сохр на серваке
    this.getUploaded().then((result) => {
        if (Array.isArray(result)) {
            result.forEach(item => {
                fetch(item.preview_url, {
                    method: 'GET',
                    mode: 'no-cors'
                })
                .then(response => response.blob())
                .then(blobFile => {
                    let file = new File([blobFile], item.fileName, {
                        type: item.type,
                    });

                    file.url             = item.preview_url;
                    file.unauthorized_id = item.unauthorized_id;

                    this.add(file, false);
                });
            });
        }
    }).catch((result) => {
        // ошибка загрузки фотки
    });
}

/**
 * Количество фотографий
 * @return {Number}
 */
PhotogalleryUploader.prototype.getLength = function() {
    return this._files.length;
}

/**
 * Создание превью
 * @param {File} file Файл, загруженный в инпут
 */
PhotogalleryUploader.prototype.add = function(file, needUpload = true) {
    if (!(file instanceof File)) {
        return;
    }

    // превышает количество
    if (this._$images.children.length >= this.options.maxFilesCount) {
        return;
    }

    // некорректный формат файла
    if (!~this._$container.dataset.accept.indexOf(file.type)) {
        return;
    }

    // превышает размер
    if (file.size >= 0 && file.size > this.options.maxFileSize) {
        return;
    }

    // сохранение файлов
    this._files.push(file);

    const $element = createElement(
        `<div class="Photogallery-uploader__image js-uploaderImage is-loading">
            <div class="preloader">
                <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path d="m12 1c0.5523 0 1 0.44772 1 1v4c0 0.55228-0.4477 1-1 1s-1-0.44772-1-1v-4c0-0.55228 0.4477-1 1-1z" clip-rule="evenodd" fill="#316BFF" fill-rule="evenodd"/>
                    <path d="m12 17c0.5523 0 1 0.4477 1 1v4c0 0.5523-0.4477 1-1 1s-1-0.4477-1-1v-4c0-0.5523 0.4477-1 1-1z" clip-rule="evenodd" fill="#316BFF" fill-rule="evenodd" opacity=".6"/>
                    <path d="m4.2231 4.223c0.39052-0.39053 1.0237-0.39053 1.4142 0l2.83 2.83c0.39053 0.39052 0.39053 1.0237 0 1.4142-0.39052 0.39053-1.0237 0.39053-1.4142 0l-2.83-2.83c-0.39053-0.39052-0.39053-1.0237 0-1.4142z" clip-rule="evenodd" fill="#316BFF" fill-rule="evenodd" opacity=".9"/>
                    <path d="m15.533 15.533c0.3906-0.3905 1.0237-0.3905 1.4142 0l2.83 2.83c0.3906 0.3905 0.3906 1.0237 0 1.4142-0.3905 0.3905-1.0236 0.3905-1.4142 0l-2.83-2.83c-0.3905-0.3905-0.3905-1.0237 0-1.4142z" clip-rule="evenodd" fill="#316BFF" fill-rule="evenodd" opacity=".5"/>
                    <path d="m1 12c0-0.5523 0.44772-1 1-1h4c0.55228 0 1 0.4477 1 1s-0.44772 1-1 1h-4c-0.55228 0-1-0.4477-1-1z" clip-rule="evenodd" fill="#316BFF" fill-rule="evenodd" opacity=".8"/>
                    <path d="m17 12c0-0.5523 0.4477-1 1-1h4c0.5523 0 1 0.4477 1 1s-0.4477 1-1 1h-4c-0.5523 0-1-0.4477-1-1z" clip-rule="evenodd" fill="#316BFF" fill-rule="evenodd" opacity=".6"/>
                    <path d="m8.4673 15.533c0.39053 0.3905 0.39053 1.0237 0 1.4142l-2.83 2.83c-0.39052 0.3905-1.0237 0.3905-1.4142 0-0.39053-0.3905-0.39053-1.0237 0-1.4142l2.83-2.83c0.39052-0.3905 1.0237-0.3905 1.4142 0z" clip-rule="evenodd" fill="#316BFF" fill-rule="evenodd" opacity=".7"/>
                    <path d="m19.777 4.223c0.3906 0.39052 0.3906 1.0237 0 1.4142l-2.83 2.83c-0.3905 0.39053-1.0236 0.39053-1.4142 0-0.3905-0.39052-0.3905-1.0237 0-1.4142l2.83-2.83c0.3906-0.39053 1.0237-0.39053 1.4142 0z" clip-rule="evenodd" fill="#316BFF" fill-rule="evenodd" opacity=".7"/>
                </svg>
            </div>
            <div class="Photogallery-uploader__image-cross js-uploaderImageRemove"></div>
        </div>`
    );

    const fileReader = new FileReader();
    fileReader.onload = () => {
        if (needUpload) {
            // загружаем на сервак
            this.uploadByOne(file).then((result) => {
                result = result[0];

                setTimeout(() => {
                    let $preloader = $element.querySelector('.preloader');
                    if ($preloader) {
                        $preloader.remove();
                    }

                    $element.insertAdjacentHTML('afterbegin', '<img src="' + fileReader.result + '">');
                }, 500);

                // запоминаем id
                if (result.id) {
                    file.unauthorized_id = result.id
                }
            }).catch((result) => {
                // ошибка загрузки фотки
                console.error(result);
            }).finally((result) => {
                if (!file.photogallery_id) {
                    let $preloader = $element.querySelector('.preloader');
                    if ($preloader) {
                        $preloader.remove();
                    }
                }
            });
        } else {
            setTimeout(() => {
                let $preloader = $element.querySelector('.preloader');
                if ($preloader) {
                    $preloader.remove();
                }

                $element.insertAdjacentHTML('afterbegin', '<img src="' + file.url + '">');
            }, 500);
        }
    }
    fileReader.readAsDataURL(file);

    // блокирование нажатий на фотки
    $element.addEventListener('click', e => {
        e.stopPropagation();
        e.preventDefault();
    });

    // клик на крестик
    const $cross = $element.querySelector('.js-uploaderImageRemove');
    $cross.addEventListener('click', e => {
        e.stopPropagation();
        e.preventDefault();
        this._files.splice(Array.from(this._$images).indexOf($element), 1);
        this._$images.removeChild($element);

        // если фоток уже максимум, то скрываем div с загрузкой
        this._$wrapper.parentNode.classList.toggle('is-hidden', this._$images.children.length == this.options.maxFilesCount);

        // показываем блок с превью если есть фотки
        this._$images.classList.toggle('is-active', this._$images.children.length > 0);

        // отправляем на сервак запрос с удалением
        this.removeByOne(file).then((result) => {
            // фотка удалилась с сервака
        }).catch((result) => {
            // ошибка удаления фотки
            console.error(result);
        });
    });

    this._$images.appendChild($element);

    // показываем блок с превью если есть фотки
    this._$images.classList.toggle('is-active', this._$images.children.length > 0);

    // если фоток уже максимум, то скрываем div с загрузкой
    this._$wrapper.parentNode.classList.toggle('is-hidden', this._$images.children.length == this.options.maxFilesCount);
}

/**
 * Загрузка изображений на сервер
 * @return {Promise} Промис, по завершении которого загружены все файлы
 */
PhotogalleryUploader.prototype.upload = function(pid, mid) {
    if (!this._files.length) {
        return Promise.reject('Нет файлов для загрузки');
    }

    pid = pid || this.options.pid;
    mid = mid || this.options.mid;
    if (!mid) {
        return Promise.reject('Не указан идентификатор модуля');
    }

    const formData = new FormData();
          formData.append('pid', pid);
          formData.append('mid', mid);
          formData.append('accept', this.options.accept.join(','));
          formData.append('maxFileSize', this.options.maxFileSize);
          formData.append('maxFilesCount', this.options.maxFilesCount);
          formData.append('exclude', this.options.exclude.join(','));
          formData.append('hash', this.options.hash);

    this._files.forEach(file => {
        formData.append('photo[]', file, file.name);
    });

    return fetch('/photogallery/upload/', {
        method: 'POST',
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
        },
        body: formData,
    })
    .then(response => response.json())
    .then(r => {
        if (r.status != 'ok') {
            throw new Error(r.message);
        }

        return r.data;
    }).catch(e => {
        console.error(e.message);
    });
}

/**
 * Загрузка изображений с сервера. Например при инициализации
 * @return {Promise} Промис, по завершении которого загружены все фотки
 */
PhotogalleryUploader.prototype.getUploaded = function(pid, mid) {
    pid = pid || this.options.pid;
    mid = mid || this.options.mid;
    if (!mid) {
        return Promise.reject('Не указан идентификатор модуля');
    }

    const formData = new FormData();
          formData.append('pid', pid);
          formData.append('mid', mid);
          formData.append('accept', this.options.accept.join(','));
          formData.append('maxFileSize', this.options.maxFileSize);
          formData.append('maxFilesCount', this.options.maxFilesCount);
          formData.append('exclude', this.options.exclude.join(','));
          formData.append('hash', this.options.hash);

    return fetch('/photogallery/get_uploaded/', {
        method: 'POST',
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
        },
        body: formData,
    })
    .then(response => response.json())
    .then(r => {
        if (r.status != 'ok') {
            throw new Error(r.message);
        }

        return r.data;
    }).catch(e => {
        console.error(e.message);
    });
}

/**
 * Загрузка изображения на сервер
 * @return {Promise} Промис, по завершении которого загружены все файлы
 */
PhotogalleryUploader.prototype.uploadByOne = function(file, pid, mid) {
    if (!file) {
        return Promise.reject('Нет файла для загрузки');
    }

    pid = pid || this.options.pid;
    mid = mid || this.options.mid;
    if (!mid) {
        return Promise.reject('Не указан идентификатор модуля');
    }

    const formData = new FormData();
          formData.append('pid', pid);
          formData.append('mid', mid);
          formData.append('accept', this.options.accept.join(','));
          formData.append('maxFileSize', this.options.maxFileSize);
          formData.append('maxFilesCount', this.options.maxFilesCount);
          formData.append('exclude', this.options.exclude.join(','));
          formData.append('hash', this.options.hash);
          formData.append('photo[]', file, file.name);

    return fetch('/photogallery/upload/', {
        method: 'POST',
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
        },
        body: formData,
    })
    .then(response => response.json())
    .then(r => {
        if (r.status != 'ok') {
            throw new Error(r.message);
        }

        return r.data;
    }).catch(e => {
        console.error(e.message);
    });
}

/**
 * Удаление изображения с сервера
 * @return {Promise} Промис, по завершении которого загружены все файлы
 */
PhotogalleryUploader.prototype.removeByOne = function(file, pid, mid) {
    if (!file) {
        return Promise.reject('Нет файла для удаления');
    }

    if (!file.unauthorized_id && !file.photogallery_id) {
        return Promise.reject('Нет photogallery_id');
    }

    pid = pid || this.options.pid;
    mid = mid || this.options.mid;
    if (!mid) {
        return Promise.reject('Не указан идентификатор модуля');
    }

    const formData = new FormData();
          formData.append('pid', pid);
          formData.append('mid', mid);
          formData.append('accept', this.options.accept.join(','));
          formData.append('maxFileSize', this.options.maxFileSize);
          formData.append('maxFilesCount', this.options.maxFilesCount);
          formData.append('exclude', this.options.exclude.join(','));
          formData.append('hash', this.options.hash);

    if (file.unauthorized_id) {
        formData.append('unauthorized_id', file.unauthorized_id);
    }

    if (file.photogallery_id) {
        formData.append('photogallery_id', file.photogallery_id);
    }

    return fetch('/photogallery/remove_by_one/', {
        method: 'POST',
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
        },
        body: formData,
    })
    .then(response => response.json())
    .then(r => {
        if (r.status != 'ok') {
            throw new Error(r.message);
        }

        return r.data;
    }).catch(e => {
        console.error(e.message);
    });
}

/**
 * Очистка списка
 */
PhotogalleryUploader.prototype.clear = function() {
    this._files = [];

    while (this._$images.lastElementChild) {
        this._$images.removeChild(this._$images.lastElementChild);
    }
}

/**
 * Событие выбора файлов
 * @param {Event} e DOM событие
 */
PhotogalleryUploader.prototype._onChange = function(e) {
    Array.prototype.forEach.call(this._$input.files, (file) => {
        this.add(file);
    });

    // даем возможность повторно загружать одну и туже фотку
    this._$input.value = null;
}

export default PhotogalleryUploader;
